import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocationService {
  private readonly ibgeUrl =
    'https://servicodados.ibge.gov.br/api/v1/localidades/estados';

  constructor(private http: HttpClient) {}

  getCitiesByState(uf: string): Observable<string[]> {
    return this.http
      .get<any[]>(`${this.ibgeUrl}/${uf}/municipios`)
      .pipe(map((items) => items.map((c) => c.nome).sort()));
  }
}

